module.exports = __webpack_public_path__ + "img/thumbnail-header-25.a6c855c.jpg";